import { useState, useEffect } from 'react';

const useDebug = () => {
  if (process.env.NODE_ENV !== 'production') {
    const [debug, setDebug] = useState(false);
    useEffect(() => {
      const toggleDebug = e => {
        if (e.ctrlKey && e.code === 'KeyD') {
          e.preventDefault();
          setDebug(oldDebug => !oldDebug);
        }
      };
      if (process.env.NODE_ENV !== 'production') {
        window.addEventListener('keydown', toggleDebug);
      }
      return () => {
        if (process.env.NODE_ENV !== 'production') {
          window.removeEventListener('keydown', toggleDebug);
        }
      };
    }, []);
    return debug ? 'debug' : '';
  }
  return '';
};

export { useDebug };
//# sourceMappingURL=useDebug.js.map
